import type { ID } from '@octopus-do/octopus-project-core'
import type { TeammateDto } from '@store/reducers/dashboard/types'
import type React from 'react'

import { MemberDropdown, MemberItem } from './components'
import css from './styles.module.css'

interface Props {
  onClick: (...keys: string[]) => void
  members: TeammateDto[]
  disabled: boolean
  authId: ID
}

const isDisabledButton = (
  disabledList: boolean,
  admin: boolean,
  personal: boolean
) => admin || (disabledList && !personal)

export const TeammatesList: React.FC<Props> = ({
  onClick,
  members,
  disabled,
  authId,
}) => {
  return (
    <ul className={css.teammates_list}>
      {members.map((member) => (
        <MemberDropdown
          key={member.id}
          disabled={disabled}
          personal={member.id === authId}
          member={member}
          onClick={onClick}
        >
          <MemberItem
            member={member}
            disabled={isDisabledButton(
              disabled,
              member.role === 'ADMIN',
              authId === member.id
            )}
          />
        </MemberDropdown>
      ))}
    </ul>
  )
}
